import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  disconnect() {
    this.unlockScroll();
  }

  open(e) {
    if (e) e.preventDefault();
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove("hidden");
      this.lockScroll();
    }
  }

  close(e) {
    if (e) e.preventDefault();
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("hidden");
    } else {
      this.element.classList.add("hidden");
      // If it's a Hotwire modal shell, it might be inside a turbo-frame that needs removal
      const frame = this.element.closest("turbo-frame");
      if (frame && frame.id === "modal") {
        frame.src = "";
        frame.innerHTML = "";
      }
    }
    this.unlockScroll();
  }

  lockScroll() {
    document.body.style.overflow = "hidden";
  }

  unlockScroll() {
    document.body.style.overflow = "auto";
  }
}
